module.exports = __webpack_public_path__ + "static/media/Combles_perdus_RT_MAX_soufflage_2021_09.450692b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Combles_perdus_RT_MAX_soufflage_2021_09.jpg
// module id = 1161
// module chunks = 0